import { ReactNode } from 'react';
import { io } from 'socket.io-client';
import { SocketContext } from '../contexts/socket.context';

const SocketProvider = ({ children }: { children: ReactNode }) => {
  const socket = io(process.env.REACT_APP_SERVER_SOCKET, {
    path: '/socket.io'
  });

  return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
};

export default SocketProvider;
